import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_OL_APPUNTAMENTO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolAppuntamentoState extends EntityState<IID_OL_APPUNTAMENTO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_APPUNTAMENTO })
@InterfaceDataStore(InterfaceName.APPUNTAMENTO)
export class IIDolAppuntamentoStore extends EntityStore<IIDolAppuntamentoState> {
  constructor() {
    super([]);
  }
}
